module.exports = __webpack_public_path__ + "static/img/partner-zg.b8238f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-zg.png
// module id = g4gp
// module chunks = 34